<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-card class="card-rounded">
      <v-form
        @submit.prevent="saveConcurso"
        ref="concursosForm"
        lazy-validation
      >
        <v-card-title>
          <span class="headline">Concurso</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <v-text-field
                  v-model="concurso.numero"
                  label="Número"
                  type="number"
                  :rules="numeroRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <v-text-field
                  v-model="concurso.valor"
                  label="Valor"
                  type="number"
                  :rules="valorRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <v-select
                  :items="concursoStatus"
                  label="Status"
                  item-text="label"
                  item-value="value"
                  :rules="statusRules"
                  required
                  v-model="concurso.status"
                  @change="onChangeStatus($event)"
                ></v-select>
              </v-col>

              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <date-picker
                  :key="dtkey"
                  :vKey="dtkey"
                  required
                  :rules="dtInicialRules"
                  :label="'Data Inicial'"
                  v-model="concurso.dataInicial"
                ></date-picker>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <date-picker
                  :key="dtfkey"
                  :vKey="dtfkey"
                  :dialog="dialog"
                  required
                  :rules="dtFinalRules"
                  :label="'Data Final'"
                  v-model="concurso.dataFinal"
                ></date-picker>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <v-text-field
                  v-model="concurso.totalnumeros"
                  label="Total de números"
                  type="number"
                  :rules="totalNumerosRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="6" sm="6">
                <v-text-field
                  v-model="concurso.numeros"
                  label="Números"
                  type="number"
                  :rules="numerosRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                v-if="encerramentoConcurso"
                cols="12"
                xl="8"
                lg="8"
                md="12"
                sm="12"
              >
                <v-text-field
                  v-model="concurso.historico"
                  label="Histórico do Ganhador"
                  :rules="historicoRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col v-if="encerramentoConcurso" cols="6">
                <v-autocomplete
                  v-model="concursoLF"
                  :items="concursosLF"
                  :loading="concursoLFSearchLoading"
                  :search-input.sync="searchConcursoLF"
                  hide-no-data
                  item-text="numero"
                  eager
                  label="Número do concurso vinculado"
                  no-data-text="Nenhum concurso encontrado"
                  prepend-icon="mdi-database-search"
                  return-object
                  :rules="concursoLfRules"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="updateLoading"
            color="primary"
            text
            @click.native="closeDialog"
          >
            Fechar
          </v-btn>
          <v-btn :disabled="updateLoading" color="primary" text type="submit">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";
import DatePicker from "../../components/date-picker.vue";
export default {
  components: {
    "date-picker": DatePicker,
  },
  props: ["dialog", "values"],
  model: {
    prop: "dialog",
    event: "change",
  },
  data() {
    return {
      updateLoading: false,
      concursoStatus: [
        { value: "previsto", label: "Previsto" },
        { value: "aberto", label: "Aberto" },
        { value: "encerrado", label: "Encerrado" },
      ],
      isInsert: true,
      numeroRules: null,
      valorRules: null,
      dtInicialRules: null,
      dtFinalRules: null,
      totalNumerosRules: null,
      numerosRules: null,
      statusRules: null,
      historicoRules: null,
      concursoLfRules: null,
      searchConcursoLF: null,
      encerramentoConcurso: false,
      dtkey: 0,
      dtfkey: 0,
      concurso: {},
      concursoLF: null,
      dataFinal: null,
      concursoLFSearchLoading: false,
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.createRules();
        if (this.values) {
          this.concurso = { ...this.values };
          //this.dataFinal = this.concurso.dataFinal;
          this.dtkey += 1;
          this.dtfkey += 1;
          this.concursoLF = this.concurso.concursoLF;
          this.$store.dispatch("setConcursosLF", [this.concursoLF]);
        } else {
          this.resetForm();
          this.concurso = {};
          this.concurso.dataInicial = new Date().toISOString().substr(0, 10);
          this.concurso.dataFinal = new Date().toISOString().substr(0, 10);
          this.dtkey += 1;
          this.dtfkey += 1;
          this.concursoLF = null;
        }
        this.onChangeStatus(null);
      } else {
        this.resetForm();
      }
    },
    searchConcursoLF(value) {
      if (value)
        if (!this.concursoLFSearchLoading && value.length >= 2) {
          if (this.concurso) {
            if (this.concurso.concursoLF) {
              if (value !== this.concurso.concursoLF.numero) {
                this.fetchConcursoLF(value);
              }
            } else {
              this.fetchConcursoLF(value);
            }
          } else {
            this.fetchConcursoLF(value);
          }
        }
    },
  },
  computed: {
    ...mapGetters({
      concursosLF: "concursosLF",
    }),
  },
  methods: {
    createRules() {
      this.numeroRules = [(v) => !!v || "Número é obrigatório"];
      this.valorRules = [(v) => !!v || "Valor é obrigatório"];
      this.dtInicialRules = [(v) => !!v || "Data Inicial é obrigatório"];
      this.dtFinalRules = [(v) => !!v || "Data final é obrigatório"];
      this.totalNumerosRules = [(v) => !!v || "Total Números é obrigatório"];
      this.numerosRules = [(v) => !!v || "Números é obrigatório"];
      this.statusRules = [(v) => !!v || "Status é obrigatório"];
      this.historicoRules = [(v) => this.historicoRule(v)];
      this.concursoLfRules = [(v) => this.concursoRule(v)];
    },
    historicoRule(v) {
      if (!v && this.concurso.status == "encerrado") {
        return "Histório do ganhador é obrigatório";
      }
      return true;
    },
    concursoRule(v) {
      if (!v && this.concurso.status == "encerrado") {
        return "Número do concurso é obrigatório";
      }
      return true;
    },
    onChangeStatus(value) {
      this.encerramentoConcurso = this.concurso.status == "encerrado";
    },
    validateForm() {
      if (this.$refs.concursosForm.validate()) {
        return true;
      }
      return false;
    },

    resetForm() {
      if (this.$refs.concursosForm) {
        this.$refs.concursosForm.reset();
      }
    },
    saveConcurso() {
      if (this.validateForm()) {
        this.concurso.concursoLF = this.concursoLF;
        this.$store
          .dispatch("saveConcurso", this.concurso)
          .then((value) => {
            if (value.type == "error") {
              this.$store.dispatch("setNotification", {
                type: "error",
                text: value.msg,
              });
            } else {
              this.$store.dispatch("setNotification", {
                type: "success",
                text: value.msg,
              });
              this.closeDialog();
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateLoading = false;
          });
      }
    },
    closeDialog() {
      this.$emit("change", false);
    },
    fetchConcursoLF(value) {
      this.concursoLFSearchLoading = true;
      this.$store
        .dispatch("fetchConcursosLF", value)
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: err,
          });
        })
        .finally(() => {
          this.concursoLFSearchLoading = false;
        });
    },
  },
};
</script>

<style></style>
